<div class="!w-full   flex     flex-col relative" style="overflow: hidden; height: 100%;">

  <mat-toolbar class="flex flex-row filter-toolbar gap-2 pr-0  !w-full " style="  width: 100%; top: 0; ">

    <h2 class="category-title   text-pretty">{{cat | async }}</h2>
    <div class="flex grow">

    </div>
    <button
    [routerLink]="['/help/how-to-use-filters']"
          aria-label="Help - read how to use filters for better product shortlisting" matTooltip="Help - read how to use filters for better product shortlisting"
          class=" border border-white hover:border-[#ff4d06]  text-white  h-[32px] w-[32px]   rounded-full  	text-sm gap-2 ">

          ?
        </button>

    <button (click)="drawer.toggle()" aria-label="filter hide or unhide" matTooltip="Product filter menu"
      class=" border border-white hover:border-[#ff4d06]  text-white h-[32px]   px-4 rounded-lg justify-self-end	flex flex-row items-center justify-center	 font-semibold	text-sm gap-2 ">
      <span> FILTERS</span>

      <!-- <mat-icon class="text-sm  ">filter_list</mat-icon> -->
      <img src="../../../../assets/graphics/filter_list_FILL0_wght400_GRAD0_opsz24.svg" alt="Filter list icon" >
    </button>

  </mat-toolbar>



    <mat-drawer-container class="example-container   scroll-smooth flex grow" style="overflow: hidden;" [hasBackdrop]="overFilter">

      <mat-drawer #drawer [mode]="!overFilter?'side':'over'"
        style="width: 200px; background-color: black; overflow: none !important;">

        <app-filters  (category)="category($event)"  (itemEvent)="filterItems($event)">

        </app-filters>




      </mat-drawer>

      <mat-drawer-content  style="overflow-x: hidden;" class="gridc relative  pt-8" >
        <!-- <a
        style="position: absolute; right: 0px; top: 0px;  "
        class="hidden md:block"
        href="https://www.vote.bestweb.lk/site/softnetcomputers_lk"
        ><img
          src="https://www.bw2024.lk/vote4us.png"
          alt="logo"
          width="150"
          height="150"
          class="drop-shadow-xl"
      /></a> -->


        @if(filteredItems.length>0){
          <div
            class="my-16 grid    justify-stretch      xs:grid-cols-1 sm:grid-cols-1 md2:grid-cols-1 md:grid-cols-1  lg2:grid-cols-2 lg:grid-cols-2  xl2:grid-cols-2 xl:grid-cols-3  2xl:grid-cols-4 ">

            @for (item of filteredItems; track $index) {

            <app-prod-card [item]="item" class="w-full flex"></app-prod-card>


            }




          </div>



        <app-footer></app-footer>


        }@else {
        <div class="w-full h-full flex flex-col   justify-center justify-items-center		">

          <!-- <ng-lottie [options]="options" class="grid-span-4 md:h-[200px] lg:h-[400px] " style=" "></ng-lottie> -->
          <span class="text-center text-7xl	 no-records">No Records</span>
        </div>

        }

      </mat-drawer-content>

    </mat-drawer-container>



</div>